import globalEnv from '~/config/env';

import { createContext } from 'react';

import type { TEnvContext } from '../types';

const EnvContext = createContext<TEnvContext>(globalEnv);

function EnvProvider({ children }: { children: JSX.Element }) {
  return <EnvContext.Provider value={globalEnv}>{children}</EnvContext.Provider>;
}

export { EnvContext as Context };
export default EnvProvider;
